import mixpanel from 'mixpanel-browser'
import Config from '../../utils/config'

export const initialize_mixpanel = () => {
  const MIXPANEL_TOKEN = Config.mixpanel;
  
  if (MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: false,
      autocapture: false
    })

    const quipa_store = localStorage.getItem('quipa-store')
    const quipa_store_json = quipa_store ? JSON.parse(quipa_store) : false
    const user_obj = quipa_store_json ? quipa_store_json.user : false
    if (user_obj && user_obj.email) {
      mixpanel.identify(user_obj.email)
      mixpanel.people.set({ $email: user_obj.email })
    }
  } else {
    console.error('Mixpanel token is missing.')
  }
}